import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "#0000ff",
          }}
        >
          {" "}
          <b>
            Sustainable Bioeconomy prospects of diatom biorefineries in the
            Indian west coast
          </b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The burgeoning population with industrialization and globalization
              has intensified the greenhouse gas (GHG) footprint with higher
              utilization of fossil energy resources. The carbon dioxide (CO
              <sub>2</sub>) level will reach 550 ppmv in 2050 [1,2]. The
              transportation sector accounts for about 21 % of the current
              global CO<sub>2</sub> emissions, next to emissions from power
              generation [2]. Coupled with this, the dwindling stock of fossil
              fuels has posed severe challenges to energy security, which
              necessitated exploring viable, sustainable energy alternatives
              that are economically viable, technically feasible,
              environmentally sound, and socially acceptable. The recent decades
              have witnessed considerable efforts towards sustainability in
              renewable energy generation. The transition to utilizing
              non-conventional sources has successfully addressed energy
              security concerns, depleting fossil fuel reserves, global warming,
              and climate change by lowering atmospheric GHG emissions [3]. The
              Intergovernmental Panel on Climate Change [4] has projected a
              sea-level rise of about 50.8 cm (at the current rate of increase)
              by 2100 due to global warming, with a 2<sup>o</sup>C rise in the
              worldwide temperature ascribed to a 2.5 % increase in CO
              <sub>2</sub> emissions per year [5]. Hence, CO<sub>2</sub>{" "}
              sequestration using biomass and exploration of sustainable
              renewable energy alternatives gained impetus among other
              industrial modes of carbon capture.
            </p>
            <p>
              During the last few decades, the development of technologies that
              capture, sequester, and biologically fix CO<sub>2</sub> has been
              on the rise. Such technologies are recognized as the most
              effective method of reducing CO<sub>2 </sub>emissions [6]. The
              ability of microalgae to biologically fix CO<sub>2</sub> is ten to
              fifty times higher than that of land plants with CO<sub>2 </sub>
              tolerance up to 40% [7]. Microalgal biorefineries are designed to
              reduce the costs involved in their production by maximizing
              resource recovery [8] and efficiently processing biomass into
              energy, platform chemicals, food additives, among others [9].
              Microalgae are considered as raw materials for biorefineries since
              they possess numerous bio components of interest, such as
              carbohydrates, pigments, and proteins that can be effectively
              utilized to minimize bio-residue.
            </p>
            <h5>1.1 Diatom as a source of oil</h5>
            <p>
              From the perspective of diatoms as a source of lipids (oil) for
              biofuel production, the contribution of the Aquatic Species
              Program [10] (ASP) is of paramount importance. It was one of the
              pioneering efforts in algal biotechnology with rigorous isolation
              of nearly 3000 microalgal species, especially from harsh
              environmental conditions like saline and brackish waters, and
              subsequent screening of algae for species with higher lipid
              content. The results of this program had provided valuable
              insights on physiology and biochemistry of algae, systems biology
              and algae production concepts using open ponds for mass
              cultivation, the chronology of research activities from
              1980&rsquo;s &ndash; 1990&rsquo;s, outdoor testing and system
              analyses, along with cost-benefit analysis. The close-out report
              on ASP identified 50 species out of the complete set of isolated
              algae to be better lipid accumulators, out of which 60% were
              diatoms. These numbers best describe the importance of diatoms,
              among other microalgae, as a significant source of lipids for
              biodiesel production [11&ndash;13].
            </p>
            <p>
              Diatoms are unicellular photosynthetic eukaryotes, playing a
              crucial role in biogeochemical cycles. Diatoms sequester carbon
              and constitute the major carbon sinks of oceans. They can be of
              freshwater or marine origin and are the most promising
              microorganisms for biofuel production [53&ndash;54]. They are the
              dominant primary producers of the oceans and efficient carbon
              sequesters, accounting for about 40 % of the marine and 20 % of
              the global primary production [15,16]. Diatoms are the most
              species-rich group among other microalgae with a reported
              30,000&ndash;2,00,000 taxa. They can thrive in extreme geological
              conditions, from deep ocean thermal vents to icy polar regions of
              the Arctic and the Antarctic [17]. They are best characterized by
              their ornate cell wall with nano-structures and are made up of
              biomineralized hydrated silica (SiO<sub>2</sub>. nH<sub>2</sub>O).
              Diatoms produce a polysaccharide -chrysolaminarin and storage
              lipid &ndash; triacylglycerol, TAG [12] in a significant quantity
              (25 &ndash; 45 % on a dry weight basis) [18]. These storage lipids
              as energy reserves induce in diatoms buoyancy to keep the diatoms
              afloat in the euphotic zones of the open oceans. &nbsp;
            </p>
            <br />
            <h5>1.2 Diatom cultivation</h5>
            <p>
              Analogous to microalgal cultivation, diatom cultivation has been
              demonstrated planktonically (as cell suspensions in culture
              medium) in open ponds and closed photobioreactors for more than 50
              years [11]. However, the past decade witnessed significant efforts
              towards biofilm-based microalgae cultivation [19]. Biofilms are
              formed by a consortium of diverse microbes such as bacteria,
              protozoa, larvae, microalgae, microzooplankton, and macroalgae
              [20]. The biofilm formation process involves the initial adherence
              by the microbial cells onto a solid substratum through adsorption,
              which is usually reversible, followed by an irreversible adherence
              with the help of secretion of EPS [21]. Microalgal cells grown on
              biofilms exhibit higher resistance and improved resilience to
              extreme and hostile environments [22]. The EPS matrix serves dual
              roles of providing storage space for nutrients and water and
              defending the cells from environmental adversities [23]. Due to
              these qualities, there has been considerable attention and shift
              in research focus from algal cultivation in suspension forms in
              open/raceway ponds to biofilm cultivation. The biofilm cultivation
              systems are submerged biofilm systems that are either continuously
              or intermittently submerged and perfused systems. A porous
              substrate provides the moisture, and the system is exposed to the
              ambient gas phase [23]. Constantly inundated systems have been
              constructed as flow-ways with mechanized pumping systems where the
              flow ways are subjected to slight inclination in angle to enable
              gravity-induced flow [24]. The constantly submerged biofilm
              cultivation systems being used so far were designed using diverse
              construction materials such as polycarbonates [25], polyvinyl
              chloride [26], concrete [27], and glass fiber-reinforced plastics
              [21].
            </p>
            <p>
              Biofilm in diatom cultivation offers multiple advantages: it has a
              lower carbon footprint area, economical, readily available with a
              re-useable supporting surface [19]; reduced harvesting costs, easy
              scalability, higher biomass productivity, lesser water requirement
              with bioremediation capability, increased light availability owing
              to the broader exposed surface area [28] and better control of
              cell growth area when cultivated in lagoons and open oceans [29].
              Biofilm-based microalgal cultivation has substantially reduced
              harvesting costs, proving its economic viability [30]. Comparative
              assessment of the water requirement for the production of 1 kg of
              microalgal biomass shows a minimal water requirement of 17 kg,
              which is ~12 times lesser than the quantum of water required for
              the same quantity cultivated under suspended cultivation using
              open ponds/photobioreactors that require 12 &ndash; 2000 kg of
              water [31]
            </p>
            <p>
              In biofilm cultivation, the colonizing tendency of benthic diatoms
              with EPS secretions has been exploited for successful biofuel
              production in biofilm bioreactors. The diatom strain{" "}
              <em>Haslea ostrearia</em>, grown in immobilized cell
              photobioreactor using agar gel layers, yielded a two-fold higher
              cell growth [32]. Earlier studies on algae production in the
              biofilm cultivation system showed dry biomass productivity as high
              as 12 &ndash; 45 g/m<sup>2</sup>/day in different parts of USA
              [33&ndash;35]. The productivity reported in such an ecologically
              engineered system is five times more than that achieved in
              conventional microalgal cultivation (open pond/raceway pond)
              systems. Although biofilm cultivation is found to perform better
              than conventional microalgal cultivation in suspension mode, ash
              content of the biomass, washing off biofilms from the substrate,
              and light penetration hindrance in a matured biofilm are the areas
              that need significant research attention.
            </p>
            <h5>2. Biofuel from diatoms: the current scenario</h5>
            <p>
              Diatoms are considered promising feedstocks for biofuel production
              worldwide due to their unique distribution of C14, C16, and C20
              fatty acids, unlike other green algae and land plants [36].
              Biofuel and biochemical potential of the marine diatom{" "}
              <em>Amphora</em> <em>coffeaformis</em> in open raceways [37],
              quality assessment of biodiesel from marine diatom{" "}
              <em>Navicula cincta</em> [36], exploration of biodiesel prospects
              of the diatom <em>Halamphora coffeaeformis</em> [38] are some of
              the global ventures on biofuel production from diatoms. In India,
              although large-scale production and utilization of diatoms as live
              feed in aquaculture has been in practice for more than five
              decades now, the mass cultivation of diatoms from a biofuel
              perspective is yet to be realized. The adversity of global warming
              and the imminent threat of freshwater scarcity have necessitated
              transitions to the microalgae of estuaries, backwaters, and open
              oceans. Moreover, it is desirable to choose microalgal strains
              optimally productive for a prolonged period under varying
              environmental conditions than a strain under controlled
              environmental conditions [12]. Thus, prioritizing microalgal
              strains for biofuel production would involve effective screening
              mechanisms that include critical factors such as abundance,
              tolerance, and higher resilience to fluctuating environmental
              conditions [39].
            </p>
            <p>
              Exploring abundantly available microalgae strains at the local
              level, &nbsp;biochemical composition, understanding physiology
              under different growth conditions, and optimization of the
              downstream processes of lipid extraction/transesterification would
              aid toward commercial scale-up for industrial utilizations. Thus,
              habitat mapping and prioritization of microalgae species are
              necessary to understand the tolerance and sensitivity levels of
              different microalgae at the local level, leading to the selection
              of resilient diatom strains. This would help in addressing
              problems encountered with the open cultivation of microalgae, such
              as the difficulty in acclimatizing microalgae to unconducive open
              environments, contamination, and invasion by pests/pathogens [40].
              The most pressing challenge in microalgae biofuel production is
              harvesting, which consumes up to 30 % of the total capital
              investment spent in biodiesel production [41].
            </p>
            <p>
              <b>
                2.1 Scope for diatom cultivation along the west coast of India
              </b>
            </p>
            <p>
              A controlled ecosystem-based approach utilizing the free energies,
              entropy, and matter of nature (solar energy and nutrients from
              wastewater) with minimal interventions of human technology would
              certainly provide low-cost solutions to manage environmental and
              energy issues due to anthropogenic activities [33,42]. The
              remediation of wastewater coupled with bioenergy generation
              through constructed wetlands [3, 19] is emerging as a viable
              ecological engineering solution. The constructed wetlands are
              tertiary treatment systems that utilize naturally occurring
              physical, chemical, and microbial processes to take up nutrients
              (NPK and micronutrients) and bioremediate wastewater [45] with the
              added benefit of biomass production [46]. Algal ponds with
              suitable locally-available substrates such as gravel stones along
              the flood plains (gazani lands) of the coast would aid in the
              phyco-remediation of surface run-off (including sewage from nearby
              localities) and sustainable biofuel production with the
              value-added products such as fodder for livestock and fertilizers
              for agricultural field [111, 150, 200]. The productivity reported
              in such ecologically engineered systems is five times (12 &ndash;
              45 g/ m<sup>2</sup>/day) more than what is achieved in
              conventional microalgae cultivation (open pond/raceway pond)
              systems. Thus, the cultivation of diatoms by introducing low-cost
              substrate for algal cell attachment along the coastal regions of
              India would provide assured benefits to the coastal fishing
              community that practices aquaculture farming in flood plains
              (gazani lands). The construction of decentralized biofuel
              production units should consider critical aspects of habitat
              conditions and seasonality of diatoms, biochemical composition
              analyses, and appropriate choice of downstream processing. Each of
              these aspects is discussed in detail in the following sections.
            </p>
            <p>
              <strong>
                <em>
                  2.1.1 Potential sites for diatom &nbsp;cultivation on the west
                  coast of &nbsp;India
                </em>
              </strong>
            </p>
            <p>
              The spatial extent of flood plains (gazani lands) that could be
              considered as potential microalgae cultivation sites along the
              west coast coastal districts of&nbsp; Uttara Kannada, Udupi, and
              Dakshin Kannada was estimated as 1940 ha. (Fig. 1) determined
              using remote sensing data (Google Earth) and QGIS (Quantum
              Geographic Information System) version 3.16. These three districts
              were chosen for the study as they fall under the administrative
              boundary of the Karnataka state. These flood plains that are under
              traditional shrimp cultivation or abandoned, integrated with
              constructed wetlands and biofilm-based algal cultivation ponds,
              provide multiple environmental and societal benefits such as (i)
              remediation of nutrient-rich wastewaters, (ii) GHG mitigation
              through carbon sequestration by microalgae, (iii) sustainable
              microalgal biomass production with less/no input energies or
              associated costs, (iv) prospects of local employment opportunities
              with the empowerment of women, (v) benefits from multiple products
              of bio-refinery including biodiesel, biogas [48], glycerol and
              fertilizers, (vi) minimal/no land-use changes as marginal lands
              are utilized and (vii) additional profits for gazani landowners.
              Similar studies on the scope of algal biofuel grown in urban
              wastewaters resulted in a lipid potential ranging from 1.94 to
              6.52 t ha<sup>-1</sup> yr<sup>-1</sup> [49].
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb1.jpg" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 1. </strong>Potential microalgae cultivation sites
              along Uttara Kannada coast
            </p>
            <p>
              Thus, in the present study, the benthic diatoms, predominant in
              estuaries and marine environments along the Uttara Kannada coasts,
              were targeted as viable biofuel feedstocks for alternative
              renewable energy production. The current research involved habitat
              mapping, seasonal dynamics, biochemical composition analyses,
              techno-economic and lifecycle assessment of biofuel, and
              value-added products in the microalgal refinery at the abandoned
              flood plains, which enhances the scope of algal biorefinery along
              the Indian west coast. The large-scale microalgae cultivation
              integrated with wastewater remediation presents a technically
              feasible, economically viable, and environmentally sound
              proposition to address the challenges of dwindling stocks of
              fossil fuel and challenges of global warming through mitigation of
              the GHG footprint.
            </p>
            <p>
              <strong>
                <em>2.1.2 Habitat mapping and prioritization of diatoms</em>
              </strong>
            </p>
            <p>
              Understanding the spatial distribution of diatoms and species
              abundance with habitat mapping in fluctuating seasonal and
              hydro-ecological conditions helps to prioritize the resilient
              group of diatoms that are viable for industrial-scale
              exploitations. Habitat mapping of the diatoms carried out in
              different lentic, and lotic systems of the Aghanashini estuary
              resulted in twenty-seven tolerant diatom species belonging to the
              genera <em>Amphora</em>, <em>Nitzschia</em>, <em>Navicula</em>,{" "}
              <em>Cyclotella, Raphoneis,</em> and <em>Pleurosigma</em>.
              Statistical analyses revealed a strong correlation between the
              environmental conditions and possible lipid potential [39]. The
              seasonal dynamics, covering all three seasons (i.e., pre-monsoon,
              monsoon, and post-monsoon), were assessed through monthly field
              investigations in the intertidal regions along the shorelines of
              the Aghanashini estuary. Statistical analyses of field data
              through agglomerative hierarchical clustering and non-metric
              multidimensional scaling (n-MDS) show a distinct variation between
              the tolerant and sensitive species. <em>Melosira </em>sp.,{" "}
              <em>Nitzschia </em>sp., <em>Cyclotella </em>sp.,{" "}
              <em>Coscinodiscus subtilis</em>,<em> Navicula </em>sp., and{" "}
              <em>Achnanthes</em> sp. including few representation species like{" "}
              <em>Melosira lineatus</em>, <em>Nitzschia acicularis</em>,{" "}
              <em>N.obtusa</em>, <em>N.sigma</em>, <em>Pleurosigma balticum</em>
              , <em>P.angulatum</em>, <em>Amphora</em> <em>salina</em>,{" "}
              <em>A.ovalis</em>, <em>Cyclotella meneghiniana</em>,{" "}
              <em>C.operculata</em>, <em>Navicula forcipata</em>,{" "}
              <em>N. weisflogii</em>, <em>N. amphisbaena</em>,{" "}
              <em>N.scutelloids</em> were prevalent across all seasons with
              varying relative abundances, exhibiting higher tolerance and
              resilience to wide fluctuations in salinities and nutrient levels
              across seasons [50].
            </p>
            <p>
              In the statistical analysis using n-MDS, cumulative season-wise
              species abundance was determined to identify the most common
              species across different sampling locations. The n-MDS plot
              represented as ordination shells (can be found in [51]) formed for
              pre- post- and monsoon seasons across stations demarcated tolerant
              species recorded year-long from sensitive species that are
              discrete to a single station. For example, diatoms like{" "}
              <em>Cyclotella meneghiniana, Melosira sp.</em>,{" "}
              <em>Coscinodiscus subtilis</em>, <em>Nitzschia obtusa</em>,{" "}
              <em>Gomphonema gracile</em> were present in the conjoining
              sections of all three ordination shells depicting tolerance with
              species presence in all three seasons at different sampling
              locations. Whereas diatoms <em>Melosira jurgensii</em>{" "}
              <em>Achnanthes brevipes and A. longipes</em>,{" "}
              <em>Amphora salina</em>, <em>Navicula amphisbaena</em>, were
              recorded only in monsoon and pre-monsoon seasons in one or more
              study stations. Fig. 2 represents diatom dynamics across seasons.
              A similar exercise of habitat mapping and species prioritization
              in other regions is required to implement decentralized biofuel
              production systems.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb2.jpg" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 2.</strong> Seasonality of diatoms across different
              seasons in the Aghanashini estuary
            </p>
            <p>
              <strong>
                <em>2.1.3 Biochemical composition analyses of diatoms</em>
              </strong>
            </p>
            <p>
              Diatoms <em>Nitzschia</em>, <em>Amphora</em>, and{" "}
              <em>Navicula</em> sp. were tolerant by exhibiting their presence
              in all seasons and showed dominance during the pre-monsoon season
              (estimated based on species richness) highest lipid productivity
              (18 &ndash; 21%) under field conditions. Hence, among the three
              tolerant diatom species, <em>Nitzschia</em> and <em>Amphora </em>
              sp. were prioritized from the nutrient-rich regions of the
              Aghanashini estuary and were analyzed for their biochemical
              composition. The diatom samples collected during the pre-monsoon
              season were pre-treated and processed to obtain dry biomass in the
              laboratory. The lipid content of the prioritized diatoms was
              estimated using the modified Folch method [52]. Cells were
              harvested (on the onset of stationary phase), and the biomass was
              stored at -20<sup>o</sup>C&nbsp; until further analysis. Lipids
              were extracted from dried biomass using the solvents chloroform,
              methanol, and water in the ratio of 2:1:0.8. Other macromolecular
              compositions of the biomass were analyzed by estimating carbon,
              hydrogen, and nitrogen content of the dried diatom biomass in a
              CHN elemental analyzer. Protein content was calculated by
              multiplying the nitrogen content by 6.28. The carbohydrate content
              in biomass was calculated by subtracting estimated percentages of
              lipids and proteins from a known quantity of biomass by heating
              the pre-weighed algal biomass to 575<sup>o</sup>C for 4 h in a
              muffle furnace. After cooling crucibles to room temperature, the
              left-over ash was weighed and subtracted with dry weight the
              mineral (ash) content.
            </p>
            <p>
              Fig. 3 illustrates the biochemical composition of the prioritized
              diatoms <em>Nitzschia</em> sp. and <em>Amphora</em> sp. The
              biochemical composition analysis of prioritized diatoms shows 27%
              lipids, 10% proteins, 53% carbohydrates, and 10% ash in{" "}
              <em>Amphora</em> sp., whereas <em>Nitzschia</em> sp. had 18% lipid
              content, 8% protein, 59% carbohydrates, and 15% ash. Nutrients
              used for diatom cultivation influence the fatty acid profiles of
              the diatoms, evident from higher proportions (up to 90 %) of
              Monounsaturated fatty acids (palmitoleic and oleic acids) and
              their saturates (C16&ndash;C18), by subjecting diatoms to glucose
              as a carbon source (mixotrophy). Thus, understanding the
              biochemical composition helps in the target extraction of
              biomolecules of interest by altering growth conditions. The lipid
              extracted from diatom <em>Nitzschia</em> sp. was transesterified
              with a biocatalyst using lipase derived from{" "}
              <em>Cladosporium </em>sp. strain CS4. A biodiesel yield of 87.2 %
              was achieved in the biocatalyst-based transesterification compared
              to 83.02 % with the acid (2 % H<sub>2</sub>SO<sub>4</sub>)
              catalyzed transesterification [53].
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb3.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 3. </strong>Biochemical composition of the
              prioritized diatoms of the Aghanashini estuary
            </p>
            <p>
              <strong>
                <em>2.1.4 Prototype bioreactor</em>
              </strong>
            </p>
            <p>
              Lab-scale bioreactor (Fig. 4) was designed using
              polypropylene-based non-reactive plastic trays, each having a
              dimension of (51 &acute; 27) cm with a footprint area of 0.1377 cm
              <sup>2</sup>. Gravel stones were placed uniformly in the tray as
              substrates for diatom attachment.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb4.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 4.</strong> Prototype bioreactor
            </p>
            <p>
              Prioritized diatom <em>Amphora </em>sp. based on habitat mapping
              and seasonal dynamics were isolated and cultured under laboratory
              conditions using f/2 media (an enriched seawater medium,
              especially used for the growth of marine diatoms) [54]. The f/2
              media used for diatom growth comprised of NaNO
              <sub>3</sub>: 75 mg L<sup>-1</sup>; Na<sub>2</sub>SiO
              <sub>3</sub>.9H<sub>2</sub>O: 30 mg L<sup>-1</sup>, NaH
              <sub>2</sub>PO<sub>4</sub>.2H<sub>2</sub>O : 5 mg L<sup>-1</sup>,
              1 mL trace metals stock solution (FeCl
              <sub>3</sub>.6H<sub>2</sub>O: 3.5 g L<sup>-1</sup>; Na2EDTA.2H
              <sub>2</sub>O: 4.36 g L<sup>-1</sup>; CuSO<sub>4</sub>.5H
              <sub>2</sub>O: 9.8 g L<sup>-1</sup>; MnCl<sub>2</sub>.4H
              <sub>2</sub>O: 180 g L<sup>-1</sup>; &nbsp;Na<sub>2</sub>MoO
              <sub>4</sub>.2H<sub>2</sub>O: 6.3 g L<sup>-1</sup>; ZnSO4.7H
              <sub>2</sub>O: 22 g L<sup>-1</sup>; CoCl<sub>2</sub>.6H
              <sub>2</sub>O: 10 g L<sup>-1</sup>) and 0.5 mL vitamin stock
              solution (vitamin B1: 200 mg L<sup>-1</sup>; Vitamin H 1 g L
              <sup>-1</sup> and Vitamin B12: 1 g L<sup>-1</sup>). The ambient
              conditions maintained for diatom culture were 25 &plusmn; 2{" "}
              <sup>o</sup>C, salinity: 35 ppt (parts per thousand) and light
              intensity: ~360 &micro;mol m<sup>-2</sup> s<sup>-1</sup> with
              14:10 hours light: dark cycle. Then pure culture isolates were
              sequentially sub-cultured to maintain cell viability. Comparative
              assessment on efficacy of harvesting and productivity assessment
              of reactors and suspended mode cultivation (in Erlenmeyer flasks)
              (where the cells are grown suspended in the water column) was
              performed. The scaled-up culture of one of the prioritized diatoms
              (<em>Amphora </em>sp.)&nbsp; with an initial biomass concentration
              of 0.187 g L<sup>-1</sup> (grams per litre) was used as an
              inoculum. The experiment was conducted in batch mode with 3.5 L of
              media as working volume both in biofilm as well as suspended mode
              cultivation in Erlenmeyer culture flasks (control) of 5L capacity.
            </p>
            <p>
              Prototype substrate-based biofilm bioreactor was constructed at
              three different stations in the flood plains of the Aghanashini
              estuary (Fig. 5) by introducing gravel stones of irregular shapes
              and sizes, with flat surface area onto a platform made of
              polyvinyl chloride (PVC) mesh (1.21 m x 1.06 m) supported with a
              frame made of PVC pipes. This prevents sediment deposition on
              substrates, which is common during tidal undulations in the
              intertidal regions of estuaries. The height of the platform was
              0.35 m above the ground level while ensuring adequate water
              contact with substrates. Two bioreactors were deployed at each
              location. Sixty granite stones of varying shapes, sizes with the
              flat surface area were deployed in each of the bioreactors, and
              the setup is given in Fig. 6. Bioreactors were continuously
              monitored for 25 days on every alternate day. Results were
              validated by repeating the experiment for another 15 days after 30
              days interval.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb5.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 5.</strong> Bioreactor deployed locations&nbsp; in
              the flood plains of the Aghanashini estuary
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb6.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 6.</strong> Substrate-based bioreactor deployed at
              field
            </p>
            <p>
              The prioritized diatom strain <em>Amphora</em> sp. was cultivated
              and monitored in a bioreactor at laboratory conditions. The growth
              rate of <em>Amphora</em> sp. was determined by measuring
              chlorophyll-a concentration every three days during the growth
              period. Chlorophyll and biomass productivity estimations were
              carried out following the protocols [55]. In addition to
              chlorophyll estimation, the viability of the cells was also
              monitored by visual examination under a high-resolution microscope
              Olympus BX 51. <em>Amphora</em> sp. followed a lag, exponential
              and stationary phase for 12 days growth cycle. The trend of
              variations in chlorophyll content of biomass in bioreactors
              (gravel stone substrate with biofilm) and conical flasks
              (suspended cultivation) are given in Fig. 7. The growth of diatoms
              in the bioreactor exhibited a lag phase till the third day, then
              entered the log phase and exhibited a higher growth rate than
              suspended cultivation. Fig. 8 depicts the light and SEM
              micrographs of <em>Amphora</em> sp.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb7.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 7,</strong> Comparison of chlorophyll content in
              biofilm and suspended Cultivation modes
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb8.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 8.</strong> Light microscopic image (a) and SEM image
              (b) of <em>Amphora </em>sp.
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              The algal (diatom) biomass harvested after 12 days of cultivation
              in the bioreactor (with substrates) and suspended cultivation was
              565.4 mg L<sup>-1</sup> and 33.37 mg L<sup>-1,</sup> respectively,
              within biomass productivity of 47.11 mg L<sup>-1</sup>d
              <sup>-1</sup> and 2.78 mg L<sup>-1</sup>d<sup>-1</sup>,
              respectively. The increase in biomass concentration of{" "}
              <em>Amphora</em> sp. in biofilm-based cultivation was ~16 times
              more than that of the suspended cultivation. The aerial biomass
              concentration and productivity obtained in substrate-based
              cultivation with biofilm are about 4.10 g m<sup>-2</sup> and 0.34
              g m<sup>-2</sup> d<sup>-1</sup>, respectively. This result
              substantiates the advantages of the substrate with biofilm for
              feedstock cultivation over conventional suspended mode
              cultivation. Elemental analysis of the harvested dried algal
              biomass of different cultivation modes through EDS FE SEM (Energy
              Dispersive X-Ray Spectroscopy in Ultra55 FE-SEM Karl Zeiss EDS at
              low KV after gold sputtering algal biomass, showed a higher carbon
              content (43.23 %) for substrate-based cultivated biomass compared
              to that under the suspended cultivation mode (38.04 %). Higher
              carbon content in biofilm cultivation with lesser carbon content
              (36.3 %) would ensure a higher calorific value of the biomass than
              suspended cultivation obtained biomass. However, the mineral ash
              content in the form of chloride (4.76 %) and calcium (2.53 %)
              found in biofilm cultivated biomass was absent in biomass of
              suspended cultivation, thus reinstating higher ash content
              encountered in biofilm cultivation. Earlier studies on the green
              microalga <em>Chlorella vulgaris</em> had shown an ash content of
              6.03 % when cultivated in a rotating algal biofilm [56] which is
              comparable with the present study. Fig. 9 illustrates the
              elemental composition acquired in SEM-EDS. Table 1 list the
              elemental composition of algal biomass in different cultivation
              modes.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb9.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 9.</strong> EDS FE SEM analysis of attached (a) and
              suspended (b) algal biomass
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Table 1.</strong> Elemental composition of algal biomass
              cultivated using different treatments
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td colSpan={3} style={styles.cell}>
                    <p>
                      {" "}
                      <strong> Attached cultivation (with biofilm)</strong>
                    </p>
                  </td>

                  <td colSpan={2} style={styles.cell}>
                    <p>
                      <strong>Suspended cultivation</strong>{" "}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>Element</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Weight%</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Atomic%</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Weight%</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Atomic%</strong>
                    </p>
                  </td>
                </tr>

                <tr>
                  <td style={styles.cell}>
                    <p>C K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>43.23</p>
                  </td>
                  <td style={styles.cell}>
                    <p>54.9</p>
                  </td>
                  <td style={styles.cell}>
                    <p>38.04</p>
                  </td>
                  <td style={styles.cell}>
                    <p>48.52</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>O K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>36.3</p>
                  </td>
                  <td style={styles.cell}>
                    <p>34.61</p>
                  </td>
                  <td style={styles.cell}>
                    <p>42.81</p>
                  </td>
                  <td style={styles.cell}>
                    <p>41</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Na K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.83</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.88</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.07</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.38</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Mg K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.45</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.54</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.78</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.75</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Si K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>4.05</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.2</p>
                  </td>
                  <td style={styles.cell}>
                    <p>9.91</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5.41</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>P K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.45</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.21</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.12</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.54</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>S K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.4</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.67</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3.27</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.41</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Cl K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>4.76</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.05</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Ca K</p>
                  </td>
                  <td style={styles.cell}>
                    <p>2.53</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.96</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Total</p>
                  </td>
                  <td style={styles.cell}>
                    <p>100</p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>100</p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              *K after each element refers to the &lsquo;n&rsquo; value that
              electrons in the shell have K electrons.
            </p>
            <p>
              Diatom samples were collected by dislodging the cells from the
              introduced substrates (stones) in the field bioreactor deployed at
              different stations, and microscopic examination of the processed
              cells was carried out to understand the variations in species
              richness and diversity. At station Bargi (BA), the diatom{" "}
              <em>Mastogloia</em> sp. and <em>Epithema gibberula</em> were the
              most abundant, with a cell density of 1.27 &times; 10<sup>4</sup>{" "}
              cells mL<sup>-1</sup> and 2.23 &times; 10<sup>4</sup> cells mL
              <sup>-1</sup>, respectively. At Kagal (KA), the predominant
              species was <em>Navicula forcipata</em> with a cell density of 7.1
              &times; 10<sup>3</sup> cells mL<sup>-1</sup>, followed by{" "}
              <em>Nitzschia panduriformis</em> with 2.6 &times; 10<sup>3</sup>{" "}
              cells mL<sup>-1</sup>. Wider variations in cell density were
              observed among triplicate samples (stones) collected at each
              station. BA station showed the highest species diversity with 15
              species, followed by KA with 12 species. Station HG was observed
              to have the least species diversity with ten different species
              with a maximum cell density of 1.4 &times; 10<sup>3</sup> cells mL
              <sup>-1</sup> recorded for the diatom <em>Nitzschia sigma</em>.
              Fig. 10 lists the optical microscopic images of diverse diatoms
              that are present in the biofilm formed at different stations.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb10.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 10.</strong> Light micrographs of processed diatom
              frustules
            </p>
            <ol>
              <li>
                <em>Mastogloia</em> b) <em>Epithema gibberula</em> c){" "}
                <em>Navicula forcipata</em> d) <em>Nitzschia panduriformis</em>{" "}
                e) <em>Epithema</em> sp. f) <em>Nitzschia</em> sp. g){" "}
                <em>Cymbella </em>sp. I) <em>Nitzschia linearis</em> j){" "}
                <em>Epithema</em> sp.
              </li>
            </ol>
            <p>
              Species composition of the daily sample exhibited significant
              variation in the species types and cell density across stations.
              The cell density of <em>Mastogloia</em> sp., at station BA was
              found to be maximum on Day 15 with a measured cell density of ~2.6
              &times; 10<sup>4</sup> cells mL<sup>-1</sup> followed by the
              diatom <em>Epithema gibberula</em> with ~1.45 &times; 10
              <sup>5</sup> cells mL<sup>-1</sup>. The station KA showed a
              dominance of the diatom <em>Navicula forcipata </em>(~7.5 &times;
              10<sup>4</sup> cells mL<sup>-1</sup>) with maximum cell density
              recorded on the 17<sup>th</sup> day of the field sampling. In the
              station HG, the diatom Navicula cincta showed its predominance
              with 4.5 &times; 10<sup>4</sup> cells mL<sup>-1 </sup>on day 15.
              Fig. 11 lists the day-wise variations in species composition at
              different study stations.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img width={600} src="images/sb11.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 11.</strong> Species composition dynamics of stations
            </p>
            <ol>
              <li>a) BA, b) KA, and c) HG</li>
            </ol>
            <p>
              Substrate-based field bioreactors' biomass productivity and yield
              show variations across stations primarily influenced by local
              environmental conditions. The biomass at BA, KA, and HG was 22.23,
              12.84, and 1.91 g m<sup>-2</sup> after 18 days of introducing
              substrata with average biomass productivity of 12.3 g m
              <sup>-2</sup> (Fig. 12). The biomass productivity values were
              calculated on an ash-free dry weight (AFDW) basis, showing areal
              biomass productivity of 1.24, 0.71, and 0.11 g m<sup>-2</sup> d
              <sup>-1</sup>. Total average productivity in the aluminium-based
              Algal Turf Scrubbing (ATS) system showed 14 g m<sup>-2</sup>. The
              wooden scrubbing system showed algal productivity of 11.7 g m
              <sup>-2</sup> [57], comparable to the present study.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb12.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 12.</strong> Biomass productivity and yield of the
              field photobioreactor
            </p>
            <p>
              Dry microalgal (diatom) biomass (about 1.2 kg) harvested from the
              field after pre-treatment was subjected to direct
              transesterification using hexane, methanol, and H<sub>2</sub>SO
              <sub>4</sub> in various batches yielded ~ 230 mL of microalgal
              biodiesel. The biodiesel property of diatom oil extracted from the
              algal biomass cultivated with biofilm was determined through
              standard protocol - Hoekman&rsquo;s equation [58]. Critical fuel
              parameters of extracted microalgal biodiesel (230 ml) like
              density, viscosity, pour point, flash point, and calorific content
              was assessed at the CSIR- Indian Institute of Chemical Technology
              (biofuel testing laboratory) Hyderabad. Fig. 13 represents the
              microalgal biodiesel extracted from field harvested diatom
              biomass. Table 2 and Table 3 compare the produced biodiesel
              quality with the International and Indian biodiesel quality
              standards.&nbsp;
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb13.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 13</strong> Biodiesel extracted from the field
              harvested microalgal biomass
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Table 2.</strong> Comparison of biodiesel quality with
              ASTM and EN biodiesel standard
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td rowSpan={2} style={styles.cell}>
                    <p>
                      <strong>Fuel property</strong>
                    </p>
                  </td>
                  <td colSpan={3} style={styles.cell}>
                    <p>
                      <strong>Algal biodiesel</strong>
                    </p>
                  </td>
                  <td colSpan={2} style={styles.cell}>
                    <p>
                      <strong>Biodiesel standard</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>BA</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>KA</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>HG</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>ASTM D6751</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>EN 14214</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Cetane number</p>
                  </td>
                  <td style={styles.cell}>
                    <p>62.4</p>
                  </td>
                  <td style={styles.cell}>
                    <p>62.2</p>
                  </td>
                  <td style={styles.cell}>
                    <p>62.5</p>
                  </td>
                  <td style={styles.cell}>
                    <p>47</p>
                  </td>
                  <td style={styles.cell}>
                    <p>51 &ndash; 120</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>HHV (MJ/kg)</p>
                  </td>
                  <td style={styles.cell}>
                    <p>38.7</p>
                  </td>
                  <td style={styles.cell}>
                    <p>38.7</p>
                  </td>
                  <td style={styles.cell}>
                    <p>38.6</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Iodine number (gI<sub>2</sub>/100 g)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>17.8</p>
                  </td>
                  <td style={styles.cell}>
                    <p>20.4</p>
                  </td>
                  <td style={styles.cell}>
                    <p>17.4</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>&lt;120</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Specific gravity (kg L<sup>-1</sup>)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.9</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.9</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.9</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.86 &ndash; 0.90</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Density (kg/m<sup>3</sup>)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>900</p>
                  </td>
                  <td style={styles.cell}>
                    <p>900</p>
                  </td>
                  <td style={styles.cell}>
                    <p>900</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>860 &ndash; 900</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Cloud point (<sup>o</sup>C)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>19.1</p>
                  </td>
                  <td style={styles.cell}>
                    <p>18.6</p>
                  </td>
                  <td style={styles.cell}>
                    <p>19.2</p>
                  </td>
                  <td style={styles.cell}>
                    <p>LD*</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Kinematic viscosity 40<sup>o</sup>C (mm<sup>2</sup> S
                      <sup>-1</sup>)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5.1</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5.2</p>
                  </td>
                  <td style={styles.cell}>
                    <p>1.9 &ndash; 6.0</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3.5 &ndash; 5.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>Avg. degree of unsaturation</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.07</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.1</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.06</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>*LD &ndash; Location dependent</p>
            <p style={{ textAlign: "center" }}>
              <strong>Table 3.</strong> Analysis of basic biodiesel quality
              parameters as per Indian biodiesel standards
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>Test</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Test Method IS:1448</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Result</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Specification limits</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Kinematic viscosity @40<sup>&ordm;</sup>C, cSt
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>ISO 3104</p>
                  </td>
                  <td style={styles.cell}>
                    <p>5.16</p>
                  </td>
                  <td style={styles.cell}>
                    <p>3.5 &ndash; 6.0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Density at 15<sup>&ordm;</sup>C, g/cm<sup>3</sup>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>ISO 3675</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.8830</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0.86 &ndash; 0.9</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Flashpoint, <sup>&ordm;</sup>C (PMCC)
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>ISO 2719</p>
                  </td>
                  <td style={styles.cell}>
                    <p>115</p>
                  </td>
                  <td style={styles.cell}>
                    <p>101 (min)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Pour Point, <sup>&ordm;</sup>C
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>P-10</p>
                  </td>
                  <td style={styles.cell}>
                    <p>0</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      Copper strip corrosion for 3 hrs @50<sup>&ordm;</sup>C
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>ISO 2160</p>
                  </td>
                  <td style={styles.cell}>
                    <p>*1a</p>
                  </td>
                  <td style={styles.cell}>
                    <p>-</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              *1a &ndash; Light orange, almost the same as freshly polished
              strip
            </p>
            <p>
              These preliminary pilot demonstration results on biofilm
              cultivation of diatoms showed promising scope for a decentralized
              biorefinery in the abandoned flood plains of the central west
              coast. Species composition and biofilm formation studies on the
              field-deployed substrate-based bioreactor showed the influence of
              environmental parameters on diatom species composition. Biodiesel
              quality testing on the field harvested biomass-derived fuel showed
              critical quality parameters to fall well within the specification
              limits of the biodiesel standards, thus proving its compatibility
              as diesel fuel. When scaled up to an industrial level, this pilot
              design would fetch assured benefits of generating decentralized
              bioenergies at local levels.
            </p>
            <p>
              <strong>
                <em>2.1.5 Techno-economic and lifecycle assessment</em>
              </strong>
            </p>
            <p>
              The techno-economic (TE) analysis of a decentralized microalgal
              biorefinery was done considering a one-hectare plot of abandoned
              gazani land (flood plain) situated in the coastal regions of
              Karnataka. Discounted cash flow model was used to determine the
              financial feasibility of the proposed microalgal cultivation
              system. The model considered 60 % of the capital investments as
              project financing loans from the National Bank for Agriculture and
              Rural Development (NABARD) with an annual loan repayment
              determined by a 4.5 % interest rate for a loan tenure of 5 years
              and the remaining 40 % of farmer&rsquo;s investment share. Loan
              options are available for micro, small and medium enterprises
              (MSME) under the supervision of the ministry of micro, small and
              medium enterprises, a branch of the Government of India (GoI).
            </p>
            <p>
              The capital and operating (fixed and variable) costs were
              determined by considering the material and energy inputs at each
              stage (Table 4). The capital costs were estimated to evaluate the
              different processes considered with equipment, transportation
              costs, and raw material requirement incurred under each unit
              operation. For cost estimations, a currency rate of 1 USD to 72.52
              INR, according to the Reserve Bank of India exchange rate as of
              March 2021, was used.
            </p>
            <p style={{ textAlign: "center" }}>
              Table 4. Methods considered for techno-economic assessment
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>S.No</strong>
                    </p>
                  </td>
                  <td colSpan={2} style={styles.cell}>
                    <p>
                      <strong>
                        Methods used for calculating techno economics of the
                        microalgal biorefinery
                      </strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Parameter</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Calculation methods</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} style={styles.cell}>
                    <p>Facility lifetime&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>30 years</p>
                  </td>
                </tr>
                <tr>
                  <td colspan={3} style={styles.cell}>
                    <p>
                      <strong>Capital cost&nbsp;</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>1.a</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Bioreactor material/fermenter procurement</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Actual prices from manufacturers.</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>1.b</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Pitching, bunding, sluice gate installation cost</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Compiled through interviews and interaction with
                      landowners and shrimp farmers.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>1.c</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Labour cost for land preparation</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Fixed as per the minimum wages act after confirming the
                      same with the current scenario in the study region.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={3} style={styles.cell}>
                    <p>
                      <strong>Operating cost</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Fixed operating cost</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>2.a</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Gazani land lease value&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      It was fixed as per the current lease trend in the study
                      region.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>2.b</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Labour cost for harvesting&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Same as 1.c.&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>2.c</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Loan repayment cost</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Calculated by considering 4.5 % interest rates on the
                      principal for a loan tenure of 5 years.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Variable costs</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>2.d</p>
                  </td>
                  <td style={styles.cell}>
                    <p>Cost of lime fertilizer and solvents&nbsp;</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Actual prices of chemicals, fertilizers, and solvents.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>2.e</p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Biodiesel production and other downstream processing costs
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Fixed as per Karnataka Electricity Regulation
                      Commission&rsquo;s standard power tariffs for industrial
                      uses.&nbsp;
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              Assuming facility lifespan of 30 years, biodiesel production cost
              (INR/kg), payback period (years), return on investment, and annual
              profit (INR/ha/yr.) was calculated using equation 1&ndash; 4
              respectively.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/sb1.png" alt="" />{" "}
            </p>
            <p>where,</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/sb2.png" alt="" />{" "}
            </p>
            <p>where,</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/sb3.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/sb4.png" alt="" />{" "}
            </p>
            <p>
              The three varying nutrient input scenarios (no nutrient input,
              wastewater input, and fertilizer input) yielded a yearly profit
              ranging between 35,296 INR/ha and 2,09,190 INR/ha based on the
              level and type of inputs during cultivation. Land preparation
              (pitching) entails leveling the land, which requires five persons
              working on the activity for 3-human days (7 hours a day) per
              hectare. Microalgae attached to substrates in a bioreactor are
              predominantly diatoms confirmed with the field experiments. This
              microalgal cultivation facility can operate for 224 days (32
              weeks), excluding the torrential monsoon period due to salinity
              dilutions, which would affect microalgal growth, and also water
              turbulence affects the initial colonization of the microalgal
              community (2 weeks).&nbsp;&nbsp;A hybrid version involving
              mechanized scrubbers and manual labor was considered for
              harvesting the microalgal biomass from the substrata. A total of
              four people working in a one-hectare plot would require two to two
              and half days to gather the biomass. The cost of harvesting is
              estimated as ~ 3 INR/m<sup>2</sup>or 20 INR/kg of microalgal
              biomass. In order to dry the algal biomass, i) direct solar
              drying; ii) filter press and subsequent solar drying were
              considered. Manual washing and sonication were the two
              pre-treatment methods considered with biodiesel production from
              dried algal biomass using direct transesterification in the
              presence of acid- and biocatalyst&rsquo;s FAME conversion
              efficiencies ranging between 83 &ndash; 87 % (based on conversion
              efficiencies of pilot lab-scale experiments). The biofuel
              production cost in a bioreactor (hectare) was estimated,
              considering all cost inputs, which vary between 30.08 INR/kg to
              59.52 INR/kg of biodiesel.
            </p>
            <p>
              The environmental assessment was performed using a cradle-to-gate
              Life cycle assessment (LCA) approach considering each process,
              right from preparation of flood plains for microalgal cultivation
              to end product (biodiesel) production. LCA considered both energy
              and GHG emissions footprints. The LCA&rsquo;s functional unit was
              defined as the algal biomass achievable in a one-hectare plot in
              the coastal flood plains of the Uttara Kannada district in
              Karnataka. Three different nutrient input scenarios, i.e., i)
              without any external nutrient inputs, (ii) in wastewater (gives an
              additional scope to assess bioremediation potential with biofuel
              production) and (iii) with external inputs&ndash;synthetic
              fertilizer, were considered for the environmental loading
              assessment. The likely energy expenditure and Carbon-di-oxide
              equivalent emissions in kilograms were computed considering 1 kg
              of biodiesel as the basis. (Further details in [59]). Life cycle
              assessment revealed a conventional fuel requirement of 3.6 &ndash;
              5.7 MJ/kg and lifecycle emission (as kg CO<sub>2e</sub> emissions)
              that varied between 0.85 &ndash; 1.46 kg CO<sub>2eq</sub>.kg
              <sup>-1</sup> of biodiesel.
            </p>
            <p>
              Mass budgeting of microalgal biorefinery by-products from
              microalgal biomass was carried out by assuming a 100 kg dry algal
              biomass. Lipid ranging between 18 &ndash; 26 % would yield 14.94
              &ndash; 22.62 kg biodiesel through transesterification with a
              by-product crude glycerol of 1.49 &ndash; 2.26 kg [60]. The spent
              algal biomass subjected to anaerobic digestion in the anaerobic
              digester would provide 24.48 m<sup>3</sup> biogas at a production
              rate of 0.272 m<sup>3</sup>/kg of biomass [61,62]. The raw biogas
              is purified/upgraded by passing on to a CO<sub>2</sub> stripper
              absorption column or can directly be used for domestic
              cooking/heating applications. About 10 % biomass loss was
              considered after lipid extraction using direct transesterification
              for accounting for the losses encountered during biomass
              processing, handling transportation, and storage of the residual
              biomass. The solid digestate in the form of a slurry (~ 55 &ndash;
              70 kg) is rich in nitrogen is useful as organic biofertilizers in
              crop fields. These results substantiate the scope of setting up a
              decentralized microalgal biorefinery along the Indian west coasts.
            </p>
            <p>
              <strong>
                <em>2.2 Diatom biorefineries </em>
              </strong>
            </p>
            <p>
              The burgeoning wastewater generation with 50 &ndash; 80% of
              wastewater being discharged to water bodies is of serious
              pollution concern worldwide [63]. Thus, resource recovery from
              wastewater using microalgal production systems is predicted as
              highly advantageous in establishing a circular bioeconomy [64].
              The diatom biomass with carbohydrates, phycobiliproteins, and
              essential fatty acids forms a viable feedstock for bioenergy and
              value-added products that warrants a circular bioeconomy by
              manifesting the basic concept of reducing, reuse, and recycling
              [65,66]. Fig. 14 illustrates pathways to utilizing algal biomass
              grown using low-cost sustainable algal production systems. Algae
              are rich in carbohydrates, which could be converted into a range
              of bioenergy components such as biogas and liquid biofuels through
              different biological processes. When subjected to anaerobic
              digestion, the carbohydrate-rich biomass would yield biogas,
              butanol, and ethanol [67]. The acetone-butanol-ethanol (ABE)
              fermentation [68] is an anaerobic fermentation process that is
              carried out using a gram-negative bacterium called{" "}
              <em>Clostridium beijerinckii. </em>Butanol is gaining prominence
              due to its superior fuel value and better storage characteristics.
              The hydrothermal liquefaction (HTL) provides a direct pathway for
              liquid biocrude production from wet algal biomass with medium
              temperature (350<sup>o</sup>C) and pressure (20 MPa) conditions
              [69]. At specified operating conditions, the liquid present in the
              algal biomass (maintained at sub-critical levels) would aid as a
              catalyst for biocrude production. Efforts are being made
              [70&ndash;72] to produce biocrude through the HTL pathway as lower
              energy is spent on biomass harvesting and drying. The harvested
              biomass, when subjected to oil extraction and subsequent
              transesterification, results in biodiesel. The microalgal biomass
              rich in pigments such as carotenoids is useful as a feedstock for
              bioactive/value-added product synthesis.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/sb14.jpg" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 14.</strong> Possible sustainable options of
              utilizing microalgal biomass
            </p>
            <ul>
              <li>
                <strong>Policy stimulus to biofuel sector in India</strong>
              </li>
            </ul>
            <p>
              India is currently engaged in accelerated research, development,
              and demonstration of sustainable and clean energy initiatives,
              increasing awareness of energy-related opportunities and
              challenges. The &nbsp;Department of Biotechnology (DBT),
              Government of India (GoI) has established four bioenergy centres
              i) DBT-ICT Centre for Energy Biosciences at the Institute of
              Chemical Technology (ICT), Mumbai; ii) DBT-IOC Centre for Advanced
              Bioenergy at the Indian Oil Corporation (IOC) at Faridabad,
              Haryana; iii) DBT-ICGEB Centre for Advanced Bioenergy Research at
              the International Centre for Genetic Engineering and Biotechnology
              (ICGEB), New Delhi and iv) DBT Pan-IIT Centre for Bioenergy
              &ndash; a nodal center having a consortium of premier Indian
              Institute of Technology institutes across different states, with a
              vision to promote biofuel technology and imbibe clean and
              renewable energy alternatives. These four initiatives have
              provided an impetus to cutting-edge research focussing on: i) new
              renewable feedstock development; ii) waste (municipal solid waste)
              to bioenergy; iii) microalgal strain improvement to enhance
              biomass productivity; iv) development of enzymes or microorganisms
              to achieve higher yields of biofuels; v) advanced biofuel and
              allied value-added products development; vi) fermentation
              technologies for ethanol production; vii) cellulolytic enzyme for
              C5 ethanol production and viii) cyanobacterial bioethanol.
            </p>
            <p>
              The biofuel research and development had a further boost with the
              revised biofuel policy of GoI (2018), of 20 % blending of ethanol
              and 5 % biodiesel blending by 2030. The DBT Pan-IIT Centre for
              Bioenergy has been working towards efficient bioprocess
              development and scale-up by integrating primary and translational
              science capabilities in algal biotechnology, synthetic biology,
              enzymes, fermentation technologies, and separation technologies
              for the production of drop-in biofuels such as biobutanol, bio
              hydrocarbons, aviation fuels, advanced biofuels and other
              value-added products (proteins, lipids, organic acids, and
              carotenoids). The Mission Innovation (MI) &ndash; a global
              intergovernmental initiative for accelerating the clean energy
              revolution, involving 24 countries and the European Commission (on
              behalf of the European Union) &ndash; was initiated in 2015. It
              aimed to identify the potential areas of clean energy research,
              revise policies for developing these potential sectors, actively
              bring in breakthroughs/achievements through public-private
              industrial collaboration and bi/multilateral international
              collaborations. In this regard, the focus of algal biofuel
              research is to bring down the costs of algal biofuel by five-folds
              by using robust, preferably marine algae grown along the seacoast
              to achieve i) higher productivity; ii) tolerance to stress; iii)
              low capital costs; iv) low energy consumption and v) efficient
              harvesting and conversion process.
            </p>
            <p>
              <strong>
                <em>3.1 Biofuel initiative at federal levels </em>
              </strong>
            </p>
            <p>
              The Karnataka State Biofuel Development Board (KBDB established in
              2009 by the Government of Karnataka) and the Karnataka State
              Biofuel Taskforce (an independent organization), in collaboration,
              are actively involved in promoting biofuel from the second
              generation (non-edible plant-based oil) feedstock-derived
              biodiesel and bioethanol from beetroots, sugarcane peels, and
              green waste molasses. The non-edible plant-based seeds that are
              well-suited for the agroclimatic condition of Karnataka are
              Jatropha, Pongamia, Neem, Simarouba, and Mahuva. In this regard,
              biofuel parks have been established at various locations to
              develop different plant varieties and manage multiple model
              processing units. The economic analysis considering one-hectare
              bioreactor revealed the cost-effectiveness of microalgal biofuel
              compared to Jatropha and Pongamia biodiesel. The Pongamia (
              <em>Pongamia pinnata</em>) plantation takes ten years to fully
              mature, yielding seeds from the fifth year. The average yield of
              Pongamia is about 3 to 5 t ha<sup>-1</sup>; it can yield up to
              ~120 kg ha<sup>-1</sup> yr<sup>-1</sup> of biodiesel, which is
              equivalent to 130.4 L ha<sup>-1</sup> yr<sup>-1</sup> along with a
              crude glycerol yield of ~76 kg ha<sup>-1</sup> as a by-product.
              The calorific value of Pongamia was estimated to be 36.5 MJ. The
              current market rate of Pongamia biodiesel is 40 INR L<sup>-1</sup>{" "}
              that could fetch a monetary benefit of 5216 INR yr<sup>-1</sup>.
              Jatropha (<em>Jatropha curcas</em>) yields a biodiesel quantity of
              656 kg ha<sup>-1</sup> yr<sup>-1</sup> [73]. Considering the
              present Jatropha biodiesel cost of 40.5 INR L<sup>-1</sup>, the
              yearly benefit from Jatropha could be 26,568 INR yr<sup>-1,</sup>{" "}
              whereas the profit from diatom-based biodiesel is 81,162 INR yr
              <sup>-1</sup>; these values are estimated based on field biofilm
              experiments and highlight the economic viability of
              third-generation biofuels.
            </p>
            <p>
              <strong>
                <em>3.2 Integrated biomass and biofuel production system</em>
              </strong>
            </p>
            <p>
              The microalgal biofuel-based large-scale commercial applications
              are usually limited by their higher operating costs related to
              nutrient inputs, low biomass production, and high energy
              requirement during harvest [74]. The US Department of Energy (DoE)
              suggests economic feasibility by coupling wastewater treatment
              with microalgal biofuel production. The efficacy of wetland
              systems was evident in removing significant amounts of organic
              matter, suspended solids, nitrogen, and phosphorus from
              nutrient-rich wastewaters [75]. The primary nutrients required for
              microalgae cultivation are carbon (organic and inorganic forms),
              nitrogen, and phosphorus [76]. Forty to fifty percent of dry
              microalgae biomass is composed of carbon followed by nitrogen
              (1&ndash;10 %), contributing to protein production. Phosphates are
              vital for photosynthetic energy transfer and the synthesis of DNA
              (deoxyribonucleic acid) and RNA (ribonucleic acid) [77]. The
              nutrient concentrations of aquaculture wastewater, depending on
              the type of fish/shrimp grown and its stocking density, typically
              range between 0&ndash;7 mg L<sup>-1</sup> ammoniacal nitrogen (NH
              <sub>4</sub>
              <sup>+</sup>), 1&ndash;25 mg L<sup>-1</sup> nitrate-nitrogen (NO
              <sub>3</sub>
              <sup>-</sup>), and 5 &ndash; 15 mg L<sup>-1</sup> ortho-phosphates
              (PO4<sup>3-</sup>); a chemical oxygen demand (COD) of
              150&ndash;250 mg L<sup>-1 </sup>causes eutrophication, dissolved
              oxygen depletion, and other associated environmental disruptions
              when discharged directly into water bodies. &nbsp;
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img width={600} src="images/sb15.png" alt="" />{" "}
            </p>{" "}
            <p style={{ textAlign: "center" }}>
              <strong>Fig. 15. </strong>Integrated algal refinery: constructed
              wetland coupled with the microalgal biofilm cultivation system
            </p>
            <p>
              The constructed wetland (consisting of local aquatic plant
              species) is integrated with a biofilm-based algal cultivation
              system as given in Fig. 15. It offers a low-cost and
              straightforward sustainable solution to moderate nutrient input to
              the system for optimal microalgal biomass productivity. The
              proposed model consists of a flood plain with cascaded sections of
              salt marsh sedges followed by a biofilm section with flat gravel
              stones. The effluent from the aquaculture ponds with typical
              nutrient concentrations of 0 &ndash; 7 mg L<sup>-1 </sup>ammonia,
              1 &ndash; 25 mg L<sup>-1</sup> nitrates, 5 &ndash; 15 mg L
              <sup>-1</sup> phosphates, and chemical oxygen demand (COD) of 150
              &ndash; 250 mg L<sup>-1</sup> drain into these flood plains either
              through the natural gradient or using solar pumps. Initially, the
              wastewater is subjected to sediment filtration and grit removal to
              reduce particulate and suspended solids. Then, the effluent passes
              through the wetland (consisting of a row of mangroves followed by
              salt marsh sedges such as <em>Porteresia coarctata</em> and{" "}
              <em>Cyperus malaccensis </em>(salt-tolerant sedges that are native
              to the Uttara Kannada district), &nbsp;and enters the biofilm
              cultivation pond. A hydraulic retention time (HRT) of 2&ndash;5
              days in the wetlands would help remove nutrients and suspended
              solids. Partially treated effluent enters the biofilm cultivation
              pond with gravel stones as substrates; this helps in the abundant
              production of microalgal biomass is to be carried out every
              3&ndash;5 days based on the prevailing environmental conditions.
              The higher levels of nutrients would lead to higher ammonia
              concentrations and species succession by blue-green algae. The
              favorable nutrient concentration levels in the biofilm cultivation
              pond are ~ &lt; 2 mg L<sup>-1</sup> NO<sub>3</sub>
              <sup>-</sup> and &lt; 1.5 mg L<sup>-1</sup> PO<sub>4</sub>
              <sup>3-</sup>,&nbsp; which is achieved by draining the aquaculture
              effluent through the constructed wetlands salt marsh sedges,
              paddy, and grass. Earlier studies on estuarine wetlands using the
              estuarine sedge <em>Juncus kraussii</em> to treat saline
              aquaculture wastewater indicate a TN (total nitrogen) and TP
              (total phosphorous) removal of 69 % and 88.5 %, respectively [78].
            </p>
            <p>
              <br />
              <br />
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
